import { StoryListFilters } from './storylist.reducer';
import { Pagination } from '../../components/Pagination';
import { Story } from '../Entities/Stories/stories.reducer';
import { actionCreatorFactory } from 'typescript-fsa';
const actionCreator = actionCreatorFactory('Story');

export const storyListSelect = actionCreator<{
  storyRow: Story;
}>('STORY_LIST_SELECT');

export const getStoryList = actionCreator('STORY_LIST_GET');
export const doStorySearch = actionCreator<{
  query: string;
}>('STORY_LIST_SEARCH');
export const updateStoryList = actionCreator<{
  storyIds: number[];
  pagination: Pagination;
}>('STORY_LIST_UPDATE');

export const pageClick = actionCreator<{ page: number }>('STORY_LIST_PAGINATE');

export const showStoryListLoading = actionCreator('LOADING_SHOW');
export const hideStoryListLoading = actionCreator('LOADING_HIDE');

export const toggleStoryListFilter = actionCreator<{
  filterKey: string;
}>('FILTER_TOGGLE');

export const updateStoryListFilters = actionCreator<{
  filters: StoryListFilters;
}>('FILTERS_UPDATE');

export const resetSearch = actionCreator('RESET_SEARCH');



// WEBPACK FOOTER //
// ./src/store/StoryList/storylist.actions.ts